import AddInstallOrderModal from './add-install-order-modal.vue'
export default AddInstallOrderModal
